import {createContext} from "react";
import {initialUserObj, IUser} from "../users/users.inteface";



export const UserContex = createContext({
    user:initialUserObj,
    setUser: (user:IUser) => {

    }
});

